import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "app-cookie-popup",
  templateUrl: "./cookie-popup.component.html",
  styleUrls: ["./cookie-popup.component.scss"],
})
export class CookiePopupComponent implements OnInit {
  @Output() consent: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  declineCookiePolicy() {
    localStorage.setItem("cookie_consent_status", "decline");
    this.consent.emit(false);
  }

  acceptCookiePolicy() {
    localStorage.setItem("cookie_consent_status", "accept");
    this.consent.emit(true);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/cookie-popup/cookie-popup.component.ts